import React from "react";
import PropTypes from "prop-types";
import { default as ReactSelect } from "react-select";

const MySelect = (props) => {
  if (props.allowSelectAll) {
    //console.log(props);
    return (
      <ReactSelect
        {...props}
        options={[props.allOption, ...props?.options]}
        onChange={(selected, event) => {
          //console.log("selected", selected);
          //console.log("event", event);
          if (selected !== null && selected.length > 0) {
            if (selected[selected.length - 1].value === props.allOption.value) {
              //console.log("all option selected", props);

              return props.onChange([ ...props.options]);
            }
            let result = [];
            if (selected.length === props.options.length) {
             // //console.log("all option selected", selected);
              if (selected.includes(props.allOption)) {
                // //console.log("all option selected", selected);
                result = selected.filter(
                  option => option.value !== props.allOption.value
                );
              } else if (event.action === "select-option") {
                result = [props.allOption, ...props.options];
              }
              return props.onChange(result);
            }
          }

          return props.onChange(selected);
        }}
      />
    );
  }

  return <ReactSelect {...props} />;
};

MySelect.propTypes = {
  options: PropTypes.array,
  value: PropTypes.any,
  onChange: PropTypes.func,
  allowSelectAll: PropTypes.bool,
  allOption: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string
  })
};

MySelect.defaultProps = {
  allOption: {
    label: "Select All",
    value: "*"
  }
};

export default MySelect;